export default function quickOrder({main, on, elm, state, subscribe}) {
	const dialog = elm.closest('dialog');

	main(_ => {
		subscribe('quick-order', prepareOrderForm);
		on('form-validation:submit', 'form', order)
	});

	const prepareOrderForm = function (data) {
		const selectedOptions = _getSelectedOptionsFromFormObject(data.form || {});
		const options = _mapOptions(data.product.options);
		const optionsData = _prepareSelectedOptionsData(selectedOptions, options);
		const mat = _prepareMatVisualisationData(selectedOptions, options);

		state.set(s => {
			s.product_id = data.form.product_id;
			s.combination_id = data.form.combination_id;
			s.quantity = data.form.quantity;
			s.options = optionsData;
			s.name = data.product.name;
			s.image = data.product.offer_image;
			s.price = data.product.price;
			s.oldPrice = data.product.oldPrice;

			if ('image' in mat) {
				s.mat = mat;
			}
		});

		dialog.showModal();
	};

	const order = async function(e, { data }) {
		const {product_id, combination_id, quantity, options, price, language, name, model} = state.get();
		const action = `index.php?route=extension/evasota/checkout/quick_order&language=${language}`;

		const productData = {
			name: data.name,
			phone: data.phone,
			product_id: product_id,
			product_name: name,
			model: model,
			combination_id,
			quantity,
			price,
			options
		};

		const loader = document.createElement('div');
		loader.classList.add('lmask');
		dialog.insertAdjacentElement('afterbegin', loader);

		try {
			const response = await fetch(action, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(productData),
			});

			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}

			const result = await response.json();

			if (result.success) {
				state.set(s => s.response = result.message);

				setTimeout(() => {
					dialog.close();
					state.set(s => s.response = '');
				}, 2000);

				const fastOrderEvent = new CustomEvent(
					'fast-order',
					{
						detail: {
							order_id: result.order_id,
							...productData,
						}
					}
				);
				document.dispatchEvent(fastOrderEvent);
			}

		} catch (e) {
			alert(`Error: ${e.message}`);
		} finally {
			loader?.remove();
		}
	};

	const _getSelectedOptionsFromFormObject = function (data) {
		return Object.entries(data)
			.reduce((acc, [key, val]) => {
				if (!key.startsWith('option') || !val) return acc;

				const match = key.match(/\[([^\]]+)\]/);
				if (match) {
					acc[match[1]] = val;
				}
				return acc;
			}, {});
	};

	const _mapOptions = function (options) {
		return Object.values(options)
			.reduce((acc, option) => {
				acc[option.product_option_id] = option;
				return acc;
			}, {});
	};

	const _prepareSelectedOptionsData = function (selectedOptions, options) {
		return Object.entries(selectedOptions)
			.map(([option_id, value_id]) => {
				const option = options[option_id];
				if (!option) return;

				let value;
				if (option.type === 'text') {
					value = {name: value_id};
				} else {
					value = option.values.find(item => item.product_option_value_id ===  value_id);
				}

				if (!value) return;

				return {
					option: option.name,
					value: value.name,
					type: option.type,
					option_id,
					value_id
				}
			});
	};

	const _prepareMatVisualisationData = function (selectedOptions, options) {
		return Object.entries(selectedOptions)
			.reduce((acc, [option_id, value_id]) => {
				const option = options[option_id];
				if (!option) return acc;

				const value = option.values.find(item => item.product_option_value_id ===  value_id);
				if (!value) return acc;

				switch (option.alias) {
					case 'patern':
						acc['image'] = `/extension/evasota/catalog/view/assets/img/cart-mat.svg#${value.code}`;
						break;
					case 'mat-color':
						acc['color_1'] = value.value;
						break;
					case 'edge-color':
						acc['color_2'] = value.value;
						break;
				}

				return acc;
			}, {});
	}
};

export const model = {
	response: '',
	product_id: 0,
	combination_id: 0,
	quantity: 1,
	options: {},
	name: '',
	model: '',
	image: null,
	price: 0,
	oldPrice: 0,
	mat: null,
};

export const view = (state) => {
	const numFormater = new Intl.NumberFormat('uk-UA');

	return {
		...state,
		displayPrice: numFormater.format(state.price) + ' ₴',
		displayOldPrice: numFormater.format(state.oldPrice) + ' ₴',
		hasDiscount: state.oldPrice > state.price,
		discount: 100 - Math.round(state.oldPrice / state.price * 100) + '%'
	}
}
